module.exports = __webpack_public_path__ + "img/新官網首頁圖-2(直).a1d98b5a.png";